import { PlanningMeasurementRequest, PlanningRequestWafer } from "@/types/planning";
import { WaferStatus } from "@/types/measurementRequest";

export type PlanningTab = "PLANNING" | "MEASUREMENT" | "MEASURED";

export const planningStatusesByTab: Record<PlanningTab, readonly WaferStatus[]> = {
  PLANNING: ["SCHEDULED", "TO_SCHEDULE"],
  MEASUREMENT: ["MEASURING", "MEASURING_FAILED", "ANALYSING", "ANALYSIS_FAILED", "MEASURED"],
  MEASURED: ["ANALYSED"],
};

export function groupPlanningRequests(
  requests: PlanningMeasurementRequest[],
  measurementSystemId: number,
) {
  const groups: Record<
    "backlog" | "planning" | "measurement" | "measured",
    PlanningMeasurementRequest[]
  > = { backlog: [], planning: [], measurement: [], measured: [] };

  requests.forEach((request) => {
    const wafersByGroup: Record<keyof typeof groups, PlanningRequestWafer[]> = {
      backlog: [],
      planning: [],
      measurement: [],
      measured: [],
    };

    request.waferRequests.forEach((wafer) => {
      if (wafer.status === "TO_SCHEDULE") {
        wafersByGroup.backlog.push(wafer);
        return;
      }
      if (measurementSystemId !== 0 && wafer.measurementSystem?.id !== measurementSystemId) {
        return;
      }

      switch (wafer.status) {
        case "SCHEDULED":
          wafersByGroup.planning.push(wafer);
          break;
        case "MEASURING":
        case "MEASURING_FAILED":
        case "ANALYSING":
        case "ANALYSIS_FAILED":
        case "MEASURED":
          wafersByGroup.measurement.push(wafer);
          break;
        case "ANALYSED":
          wafersByGroup.measured.push(wafer);
          break;
      }
    });

    const groupNames: (keyof typeof groups)[] = ["backlog", "planning", "measurement", "measured"];
    groupNames.forEach((group) => {
      if (wafersByGroup[group].length > 0) {
        groups[group].push({ ...request, waferRequests: wafersByGroup[group] });
      }
    });
  });

  return groups;
}
